
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("duW1j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $9d3b154f17f86727$var$_jquery = $9d3b154f17f86727$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $9d3b154f17f86727$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $9d3b154f17f86727$var$init = module.exports.init = function init() {
    // -------------------------------------------------------------
    // facebook share
    // -------------------------------------------------------------
    window.fbShare = function(url, title, descr, image, winWidth, winHeight) {
        var winTop = screen.height / 2 - winHeight / 2;
        var winLeft = screen.width / 2 - winWidth / 2;
        var shareurl = encodeURIComponent(url);
        var baseURL = "https://www.facebook.com/dialog/share?%20app_id=1603843519910518%20&href=";
        if (typeof image != "undefined" && image.length > 0) window.open("" + baseURL + shareurl + "&display=popup&picture=" + image + "&description=" + descr + "&caption=BFDW", "teilen", "top=" + winTop + ",left=" + winLeft + ",toolbar=0,status=0,width=" + winWidth + ",height=" + winHeight);
        else window.open("" + baseURL + shareurl + "&display=popup&description=" + descr + "&caption=BFDW", "teilen", "top=" + winTop + ",left=" + winLeft + ",toolbar=0,status=0,width=" + winWidth + ",height=" + winHeight);
    };
    // -------------------------------------------------------------
    // twitter share
    // -------------------------------------------------------------
    window.bsShare = function(url, text, image, winWidth, winHeight) {
        var winTop = screen.height / 2 - winHeight / 2;
        var winLeft = screen.width / 2 - winWidth / 2;
        var tweeturl = encodeURIComponent(url);
        var tweettext = "";
        if (typeof image != "undefined" && "" != image) tweettext += image + " - ";
        window.open("https://bsky.app/intent/compose?text=" + tweeturl + "&text=" + text, "teilen", "top=" + winTop + ",left=" + winLeft + ",toolbar=0,status=0,width=" + winWidth + ",height=" + winHeight);
    };
    // -------------------------------------------------------------
    // whatsapp share
    // -------------------------------------------------------------
    window.waShare = function(url, text, image, winWidth, winHeight) {
        var winTop = screen.height / 2 - winHeight / 2;
        var winLeft = screen.width / 2 - winWidth / 2;
        var shareurl = encodeURIComponent(url);
        window.open("https://wa.me/?text=" + shareurl, "teilen", "top=" + winTop + ",left=" + winLeft + ",toolbar=0,status=0,width=" + winWidth + ",height=" + winHeight);
    };
};

});


//# sourceMappingURL=social.module.b7fe514a.js.map
